import React, { useEffect, useState } from 'react';
import { baseUrl } from '../components/BaseUrl';
import { paystackUrl } from '../components/PaystackUrl';
import axios from 'axios';
import Swal from "sweetalert2";
import moment from 'moment';

const CheckActiveSubscription = () => {
    const [loading, setLoading] = useState(false);
    const [secretKey, setSecretKey] = useState('');
    const [hasFetchedSecretKey, setHasFetchedSecretKey] = useState(false);

    useEffect(() => {
        const initialize = async () => {
            await fetchSecretKey();
        };
        initialize();
    }, []);

    useEffect(() => {
        if (hasFetchedSecretKey && secretKey) {
            fetchSubscription();
        }
    }, [hasFetchedSecretKey, secretKey]);

    const fetchSecretKey = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("codefussion-login-token");
            if (!token) {
                throw new Error('No authentication token found');
            }

            const response = await axios.get(`${baseUrl}get_secret_key.php`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            });
            
            if (response.data.status === 1) {
                setSecretKey(response.data.secret_key);
                setHasFetchedSecretKey(true);
            } else {
                throw new Error(response.data.message || 'Failed to get secret key');
            }
        } catch (error) {
            console.error('Error fetching secret key:', error);
            Swal.fire({
                title: "Security Error",
                text: "Failed to initialize security settings. Please try logging in again.",
                icon: "error",
                confirmButtonText: "OK",
            }).then(() => {
                window.location.replace("/login");
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchSubscription = async () => {
        if (!secretKey) {
            console.error('No secret key available');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(`${paystackUrl}customer/${localStorage.getItem("codefussion-student-email")}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${secretKey}`
                }
            });

            if (response.data.data.subscriptions.length > 0) {
                response.data.data.subscriptions.forEach((item) => {
                    fetchPlan(item.subscription_code);
                });
            } else {
                checkPlan();
            }
        } catch (error) {
            checkPlan();
        } finally {
            setLoading(false);
        }
    };

    const fetchPlan = async (id) => {
        if (!secretKey) {
            console.error('No secret key available');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(`${paystackUrl}subscription/${id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${secretKey}`
                }
            });

            console.log(response);
            if (response.data.data.status === 'active') {
                localStorage.setItem("codefussion-subscription-status", "active");
                localStorage.setItem("interval", response.data.data.plan.interval);
                Swal.fire({
                    title: "Active Subscription",
                    text: "You have an subscription",
                    icon: "success",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                }).then(() => {
                    saveLogin();
                });
            } else if (response.data.data.status === 'attention') {
                localStorage.setItem("codefussion-subscription-status", "expired");
                Swal.fire({
                    title: "Expired Subscription",
                    text: "Your subscription has expired",
                    icon: "error",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                }).then(() => {
                    window.location.replace("/plans");
                });
            } else {
                localStorage.setItem("codefussion-subscription-status", "expired");
                Swal.fire({
                    title: "Inactive Subscription",
                    text: "You do not have an subscription",
                    icon: "error",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                }).then(() => {
                    window.location.replace("/plans");
                });
            }
        } catch (error) {
            console.error('Error fetching plan:', error);
        } finally {
            setLoading(false);
        }
    };

    const saveLogin = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const randomString = Math.random().toString(20).substring(2, 14) + Math.random().toString(20).substring(2, 14);
        const deviceID = `${userAgent}-${platform}-${randomString}`;
        setLoading(true);
        
        const userData = {
            email: localStorage.getItem("codefussion-student-email"),
            interval: localStorage.getItem("interval"),
            platform: deviceID
        };
        
        axios.post(`${baseUrl}add-login.php`, userData).then((response) => {
            if (response.data.message === "Login limit exceeded.") {
                Swal.fire({
                    title: "Login Limit Exceeded",
                    text: "Login limit exceeded for this account.",
                    icon: "error",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                });
                setLoading(false);
            } else if (response.data.message === "Login saved.") {
                window.location.replace("/dashboard");
                setLoading(false);
            } else {
                Swal.fire({
                    title: "Error",
                    text: "An error occurred. Please try again later",
                    icon: "error",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                }).then(() => {
                    window.location.replace("/login");
                });
            }
        });
    };

    const checkPlan = () => {
        const token = localStorage.getItem("codefussion-login-token");
        setLoading(true);
        
        const userData = {
            email: localStorage.getItem("codefussion-student-email"),
        };
        
        axios.post(`${baseUrl}get-payment-id.php`, userData, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: token
            }
        }).then((response) => {
            let date = "";
            let today = moment().startOf('day');
            
            if (response.data.length > 0) {
                response.data.forEach((item) => {
                    if (item.status === 1) {
                        date = item.date_created;
                        var createdDate = moment(date, "YYYY-MM-DD").startOf('day');
                        var diff = today.diff(createdDate, 'days');
                        if (diff >= 360) {
                            Swal.fire({
                                title: "Inactive Subscription",
                                text: "You do not have an subscription",
                                icon: "error",
                                confirmButtonText: "OK",
                                backdrop: `
                                rgba(143, 70, 0, 0.3)
                                url("")
                                left top
                                no-repeat
                                `
                            }).then(() => {
                                window.location.replace("/plans");
                            });
                            setLoading(false);
                        } else {
                            localStorage.setItem("codefussion-subscription-status", "active");
                            localStorage.setItem("plan", item.code);
                            Swal.fire({
                                title: "Active Subscription",
                                text: "You have an subscription",
                                icon: "success",
                                confirmButtonText: "OK",
                                backdrop: `
                                rgba(143, 70, 0, 0.3)
                                url("")
                                left top
                                no-repeat
                                `
                            }).then(() => {
                                saveLogin();
                            });
                        }
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: "An error occurred. Please try again later",
                            icon: "error",
                            confirmButtonText: "OK",
                            backdrop: `
                            rgba(143, 70, 0, 0.3)
                            url("")
                            left top
                            no-repeat
                            `
                        }).then(() => {
                            window.location.replace("/plans");
                        });
                    }
                });
            } else {
                Swal.fire({
                    title: "Inactive Subscription",
                    text: "You do not have an active subscription",
                    icon: "error",
                    confirmButtonText: "OK",
                    backdrop: `
                    rgba(143, 70, 0, 0.3)
                    url("")
                    left top
                    no-repeat
                    `
                }).then(() => {
                    window.location.replace("/plans");
                });
            }
        });
    };

    return (
        <div>
            {loading ? 
                <center>
                    <div className="loader-wrapper" id="loading">
                        <div className="loader">
                            <div className="loader loader-inner"></div>
                        </div>
                    </div>
                </center> 
                : null 
            }
        </div>
    );
};

export default CheckActiveSubscription;